import *  as TYPES from './mutation-types'
import {loginByUnionId, loginByCode, refreshLogin, register, addCart as addCartAPI} from '../api/common'
import {orderCheck, createOrder as createOrderAPI, selectCoupon} from '../api/order'

export const autoLogin = async ({dispatch}) => {
  if (agent.isWechat) {
    if (db.wx_openId) {
      const obj = await loginByUnionId(db.wx_unionId);

      if (obj.code == 0) {
        const data = obj.data;
        if (data.user) {
          dispatch(TYPES.LOGIN, data);
        }
      }
    } else if (db.wx_code) {
      const obj = await loginByCode(db.wx_code);

      if (obj.code == 0) {
        const data = obj.data;
        if (data.user) {
          dispatch(TYPES.LOGIN, data);
        }

        db.wx_unionId = data.unionId;
        db.wx_openId = data.openId;
      }
    }

  } else {
    //测试用
    const obj = await refreshLogin();
    if (obj.code == 0) {
      const data = obj.data;

      if (data.user) {
        dispatch(TYPES.LOGIN, data);
        db.wx_unionId = data.user.WxUnionId;
        db.wx_openId = data.user.openId;
      }
    }
  }
};

export const login = async ({dispatch}, phone, captcha) => {
  const obj = await register(
    phone, captcha, db.wx_unionId
  );

  if (obj.code === 0) {
    dispatch(TYPES.LOGIN, {user: obj.data});
  }

  return obj;
};


export const addCart = async ({dispatch}, sku_id, quantity) => {
  const obj = await addCartAPI(sku_id, quantity);

  if (obj.code === 0) {
    dispatch(TYPES.ADD_CART, obj.data.count);
  }
  return obj;
};


export const newOrder = async ({dispatch}, skus) => {
  const res = await orderCheck(skus);

  if (res.isOk) {
    dispatch(TYPES.NEW_ORDER, res.data);
  }

  return res
};

export const createOrder = async ({dispatch, state}, remark) => {

  const conditions = {
    skus: {}
  };
  try {

    if (!state.order.authentication)
      conditions['addressId'] = state.order.address._id;

    state.order.skus.map((sku) => {
      conditions.skus[sku._id] = sku.quantity;
    });

    if (state.order.coupon)
      conditions.couponId = state.order.coupon._id;

    if (remark)
      conditions.remark = remark;


    const res = await createOrderAPI(conditions);

    if (res.isOk) {
      dispatch(TYPES.CREATE_ORDER, res.data);
    }
    return res

  } catch (e) {
    console.log(e)
  }
};

export const changeOrderAddress = ({dispatch}, address) => {
  dispatch(TYPES.CHANGE_ORDER_ADDRESS, address);
};

export const changeOrderCount = ({dispatch}, {i, num}) => {
  dispatch(TYPES.ORDER_CHANGE_COUNT, {i, num});
};

export const changeOrderCoupon = async ({dispatch, state}, coupon) => {
  // if (state.order.coupon && coupon._id === state.order.coupon._id) {
  //   return {
  //     isOk: true
  //   }
  // }

  const skus = {};
  state.order.skus.map(sku => skus[sku._id] = sku.quantity);
  const res = await selectCoupon(coupon._id, skus);

  if (res.isOk) {
    dispatch(TYPES.CHANGE_ORDER_COUPON, res.data)
  }

  return res
};



// WEBPACK FOOTER //
// ./src/stores/actions.js